import ToggledCheckboxes from "./ToggledCheckboxes"

type JobFilter = {
  title: string
  checkboxes: string[]
  activeFilters: string[]
  setFilterFunction: React.Dispatch<React.SetStateAction<string[]>>
  initiallyOpen: boolean
}

export type TJobFilters = JobFilter[]

interface JobFiltersProps {
  filters?: TJobFilters
}

const JobFilters: React.FC<JobFiltersProps> = ({ filters }) => {
  if (!filters) {
    return null
  }

  return (
    <>
      {filters.map((filter) => {
        const {
          title,
          checkboxes,
          activeFilters,
          setFilterFunction,
          initiallyOpen,
        } = filter
        return (
          checkboxes.length > 0 && (
            <ToggledCheckboxes
              key={title}
              title={title}
              checkboxes={checkboxes}
              activeFilters={activeFilters}
              setFilterFunction={setFilterFunction}
              initiallyOpen={initiallyOpen}
            />
          )
        )
      })}
    </>
  )
}

export default JobFilters
